import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/loading.gif'
import _imports_2 from '../assets/error.gif'

const _withId = /*#__PURE__*/_withScopeId("data-v-e07ea082")

_pushScopeId("data-v-e07ea082")
const _hoisted_1 = { id: "entire_app__available_routes" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ticking_procedure_background" }, null, -1)
const _hoisted_3 = { class: "ticket_booking_procedure_container" }
const _hoisted_4 = { class: "procedure_form" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ticking_procedure_background loading_data_background" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "error_occurred_container" }, [
  /*#__PURE__*/_createVNode("div", { class: "alert_container loading_container col-mob-11" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "logo col-mob-5",
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createVNode("img", {
      class: "loader",
      src: _imports_1,
      alt: ""
    })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ticking_procedure_background" }, null, -1)
const _hoisted_8 = { class: "error_occurred_container" }
const _hoisted_9 = { class: "alert_container col-mob-11" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "error_image" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_11 = { class: "error_message" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h2", null, "Oops . . Booking failed!", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", null, "Error:", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "Try acting accordingly to the error and if any problem contact our team.", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "ticking_procedure_background" }, null, -1)
const _hoisted_16 = { class: "error_occurred_container" }
const _hoisted_17 = { class: "alert_container col-mob-11" }
const _hoisted_18 = { class: "error_message favourite_company col-mob-11" }
const _hoisted_19 = /*#__PURE__*/_createVNode("h2", null, "Add a favourite company", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", {
  selected: "",
  value: ""
}, "Select favourite company", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, "Adding a favourite company helps us to give you best tickets.", -1)
const _hoisted_22 = { class: "btns" }
const _hoisted_23 = {
  key: 1,
  class: "entire_app_mobile_sidebar_container"
}
const _hoisted_24 = { class: "__mobile_navigation" }
const _hoisted_25 = { class: "logo_container" }
const _hoisted_26 = { class: "menu_toggle" }
const _hoisted_27 = /*#__PURE__*/_createVNode("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M0,0H28V28H0Z",
  fill: "none"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z",
  transform: "translate(0)",
  fill: "#1d2329"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_30 = { class: "settings" }
const _hoisted_31 = /*#__PURE__*/_createVNode("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M0,0H28V28H0Z",
  fill: "none"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z",
  transform: "translate(0 0)",
  fill: "#1d2329"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ticket_booking = _resolveComponent("ticket-booking")
  const _component_sidebar = _resolveComponent("sidebar")
  const _component_mobile_sidebar = _resolveComponent("mobile-sidebar")
  const _component_router_link = _resolveComponent("router-link")
  const _component_favourite_filters = _resolveComponent("favourite-filters")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: [{'--booking_in_progress': _ctx.$store.state.Booking.bookingInProgress}, "ticket_booking_order"]
    }, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_ticket_booking, { ticketId: _ctx.ticketId }, null, 8, ["ticketId"])
        ])
      ])
    ], 2),
    (_ctx.$store.state.SidebarToggle.loadingPageData)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: [{'--booking_in_progress': _ctx.$store.state.SidebarToggle.loadingPageData}, "ticket_booking_order"]
        }, [
          _hoisted_5,
          _hoisted_6
        ], 2))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: [{'--booking_in_progress': _ctx.$store.state.Booking.ticket_expired_error}, "ticket_booking_order"]
    }, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("h4", null, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.$store.state.Booking.ticket_expired_error_msg), 1)
            ]),
            _hoisted_14,
            _createVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.commit('Booking/removeBookingerrors')))
            }, "Okay, Understood")
          ])
        ])
      ])
    ], 2),
    _createVNode("div", {
      class: [{'--booking_in_progress': _ctx.$store.state.SidebarToggle.adding_favourite_company}, "ticket_booking_order"]
    }, [
      _hoisted_15,
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.favourite_company = $event))
            }, [
              _hoisted_20,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.SidebarToggle.all_favourite_companies, (compy) => {
                return (_openBlock(), _createBlock("option", {
                  key: compy,
                  value: compy
                }, _toDisplayString(compy), 9, ["value"]))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.favourite_company]
            ]),
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _createVNode("button", {
                class: "cancel",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$store.commit('SidebarToggle/change_adding_fav_status')))
              }, "Cancel action"),
              _createVNode("button", {
                disabled: _ctx.favourite_company == '',
                class: "add",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$store.commit('SidebarToggle/addFavCompany', _ctx.favourite_company)))
              }, "Add favourite", 8, ["disabled"])
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode("div", {
      class: ["entire_app__sidebar_container", {'--sidebar_toggled': _ctx.$store.state.SidebarToggle.sidebar_toggled}]
    }, [
      _createVNode(_component_sidebar)
    ], 2),
    (_ctx.$store.state.Customizations.mobile_siderbar_toggled)
      ? (_openBlock(), _createBlock("div", _hoisted_23, [
          _createVNode(_component_mobile_sidebar)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_24, [
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          (_openBlock(), _createBlock("svg", {
            id: "menu",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$store.commit('Customizations/togglemobilesidebar'))),
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 28 28"
          }, [
            _hoisted_27,
            _hoisted_28
          ]))
        ]),
        _hoisted_29,
        _createVNode("div", _hoisted_30, [
          _createVNode(_component_router_link, { to: "/profile" }, {
            default: _withId(() => [
              (_openBlock(), _createBlock("svg", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$store.commit('Customizations/togglemobilesidebartofalse'))),
                id: "settings",
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 28 28"
              }, [
                _hoisted_31,
                _hoisted_32
              ]))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", {
      class: ["entire_app__page_content", {'--sidebar_toggled_expd_body': _ctx.$store.state.SidebarToggle.sidebar_toggled}]
    }, [
      _createVNode(_component_favourite_filters)
    ], 2)
  ]))
})